import { NavBarBtnModel } from '../../../../models';

export const NavBarButtons: NavBarBtnModel[] = [
  {
    classes: 'btn-grey',
    text: 'BUTTON.CANCEL',
    iconName: 'close',
    disabled: false,
    actionName: 'onCloseClick',
  },
  {
    classes: 'btn-primary create-category-dropdown-btn',
    text: 'BUTTON.CREATE',
    iconName: 'plus',
    allowLoadingSpinner: true,
    actionName: 'onCreateClick',
    disabled: false,
    actions: [
      {
        actionTitle: 'BUTTON.CREATE',
        actionName: 'onCreateClick',
        actionIcon: 'plus'
      },
      {
        actionTitle: 'BUTTON.CREATE_AND_SET_UP',
        actionName: 'onCreateAndSetupClick',
        actionIcon: 'grid'
      }
    ]
  },
];
